document.addEventListener('DOMContentLoaded', () => {  
  const header = document.querySelector('.header-section')
  let resizeTimer

  if(!!header === false) return
  
  document.body.setAttribute('data-mobile-nav-fix', true) 
  
  recalcMobileNavPosition()
  new ResizeObserver(() => {
    recalcMobileNavPosition()
  }).observe(header)

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer)
    setTimeout(() => {
      recalcMobileNavPosition()
    }, 50)    
  })

  document.addEventListener('click', e => {
    let el = e.target
    let match = false
    do {
      match = el.matches('.mobile-nav-trigger')
      el = el.parentNode
    } while (match === false && el && el !== document.body)
    if(match) recalcMobileNavPosition()
  })

  function recalcMobileNavPosition() {
    const headerBounding = header.getBoundingClientRect()
    const top = headerBounding.y + headerBounding.height
    document.body.style.setProperty('--mobileNavFixedTop', top + 'px')
    document.body.style.setProperty('--mobileNavFixedMaxHeight', window.innerHeight - top + 'px')
  } 
})